/**
 * Sends the browser to an OAuth authorize URL. With `newTab`, it opens a new
 * tab and keeps the current page, so a provider screen that never redirects
 * back (Slack's "waiting for admin approval") can't strand the user. When the
 * browser blocks the tab, it falls back to navigating the current one.
 *
 * `noopener` is left out on purpose: with it, `window.open` returns `null`
 * even on success, so a blocked tab looks the same as an opened one. The
 * opener is severed by hand instead (same approach as `openBookCallLink`).
 */
export const openAuthorizeUrl = (url: string, { newTab = false } = {}) => {
  if (newTab) {
    const tab = window.open(url, '_blank');
    if (tab) {
      tab.opener = null;
      return;
    }
  }

  window.location.assign(url);
};
